import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as XLSX from 'xlsx';

const Container = styled.div`
    display:flex;
    align-items: center;
    justify-content:center;
    flex-direction: row;
    width:100%;
    height:100%;
    min-width:100%;
`;

const UploadFileContainer = styled.div`
    display:flex;
    align-items: center;
    justify-content:center;
    flex-direction: column;
    width:50%;
    height:90%;
    border-right: 2px solid #eee;

    & > h2 {
      margin:10px;
    }
`;

const CopyPasteContainer = styled.div`
    display:flex;
    align-items: center;
    justify-content:center;
    flex-direction: column;
    width:50%;
    height:90%;

    & > h2 {
      margin:10px;
    }

    & textarea {
      width:100%;
      height: 175px;
      background: #ecf2f8;
      border: 1px solid #bdd0db;
      outline: none;
      padding:7.5px;
      resize: none;
    }
`;

const CTAArea = styled.div`
    display:flex;
    align-items: center;
    justify-content:space-between;
    flex-direction: column;
    width:60%;
    height:40%;
`;

const TextArea = styled.div`
    display:flex;
    align-items: center;
    justify-content:flex-end;
    flex-direction: column;
    width:50%;
    height:40%;
    padding-bottom: 25px;
    & > h3 {
      font-size: 32px;
      margin: 12.5px;
      color: #335B80;
      font-weight: 700;
    }
    & > p {
      font-size: 16px;
      margin: 2.5px;
      color: #335B80;
    }
`;

const DownloadExcelFile = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width:200px;
    height: 40px;
    border:none;
    color:#335B80;
    font-size: 16px;
    text-decoration: none;
    border-radius: 2.5px;
    border: 1px solid #335B80;
    cursor: pointer;
    padding: 0px 10px;
    transition: all 0.5s;
    border: 1px solid #335B80;
    &:hover {
      opacity: 0.5;
    }
`;

const uploadButton = (buttonTitle, handleImportedFile, appTexts) => (
  <label htmlFor="file-upload" className="import-file-upload-button">
    {buttonTitle}
    <input
      id="file-upload"
      type="file"
      onChange={event => handleImportedFile(event.target.files, appTexts)}
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    />
  </label>
);

const generateNewDownloadableExcelFile = (isBirthDateMandatory, reservationCode, appTexts, cabindIds) => {
  let text = appTexts;
  const filename = `StenaLine-${reservationCode || 'Reservation-Template'}.xlsx`;
  if (!isBirthDateMandatory) {
    text = text.filter(text => text && Object.keys(text).toString().toLowerCase() !== 'dateofbirth');
  }
  if (cabindIds.length === 0) {
    text = text.filter(text => text && Object.keys(text).toString().toLowerCase() !== 'cabin');
  }
  const data = (text && text.map(t => t && Object.values(t))).reduce((a, b) => [...a, ...b], []) || [];

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([data]);
  const wscols = [
    { wch: 15 },
    { wch: 15 },
    { wch: 20 },
    { wch: 12 },
    { wch: 15 },
    { wch: 15 },
    { wch: 12 },
  ];
  wb.Props = {
    Title: filename,
    Author: 'Stena IT',
    Manager: 'Stena IT',
    Company: 'Stena IT',
    CreatedDate: new Date(),
  };

  ws['!cols'] = wscols;
  XLSX.utils.book_append_sheet(wb, ws, filename);
  XLSX.writeFile(wb, filename);
};

const UploadFile = ({
  buttonTitle,
  textTitle,
  textExplanation,
  copyPasteTitle,
  copyPasteExplanation,
  copyPastePlaceholder,
  downloadTemplateTitle,
  handleImportedFile,
  pasteDataFromClipboard,
  appTexts,
  reservationCode,
  isBirthDateMandatory,
  cabindIds,
}) => (
  <Container>
    <UploadFileContainer>
      <TextArea>
        <h3>{textTitle}</h3>
        <p>{textExplanation}</p>
      </TextArea>
      <CTAArea>
        {uploadButton(buttonTitle, handleImportedFile, appTexts)}
        <DownloadExcelFile
          onClick={() => generateNewDownloadableExcelFile(isBirthDateMandatory, reservationCode, appTexts, cabindIds)}
        >
          {downloadTemplateTitle}
        </DownloadExcelFile>
      </CTAArea>
    </UploadFileContainer>
    <CopyPasteContainer>
      <TextArea>
        <h3>{copyPasteTitle}</h3>
        <p>{copyPasteExplanation}</p>
      </TextArea>
      <CTAArea>
        <textarea onPaste={pasteDataFromClipboard} placeholder={copyPastePlaceholder} />
      </CTAArea>
    </CopyPasteContainer>
  </Container>
);

UploadFile.propTypes = {
  buttonTitle: PropTypes.string,
  textTitle: PropTypes.string,
  textExplanation: PropTypes.string,
  copyPasteTitle: PropTypes.string,
  copyPasteExplanation: PropTypes.string,
  copyPastePlaceholder: PropTypes.string,
  downloadTemplateTitle: PropTypes.string,
  handleImportedFile: PropTypes.func,
  pasteDataFromClipboard: PropTypes.func,
  appTexts: PropTypes.array,
  reservationCode: PropTypes.string,
  isBirthDateMandatory: PropTypes.bool,
  cabindIds: PropTypes.array,
};

export default UploadFile;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/steps/uploadFile.js